import React, { useEffect, useState } from "react";
// @material-ui/core components
import {
  Box,
  Dialog,
  Fab,
  IconButton,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  useMediaQuery,
  useTheme,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  FormHelperText,
  InputAdornment,
} from "@material-ui/core";
// core components
import DateUtils from "@date-io/moment";

import GridItem from "../../components/Grid/GridItem.js";
import GridContainer from "../../components/Grid/GridContainer.js";
import CustomInput from "../../components/CustomInput/CustomInput.js";
import Button from "../../components/CustomButtons/Button.js";
import Card from "../../components/Card/Card.js";
import CardHeader from "../../components/Card/CardHeader.js";
import CardBody from "../../components/Card/CardBody.js";
import CardFooter from "../../components/Card/CardFooter.js";
import axios from "axios";
import {
  CreateBankAPI,
  CreatePaymentAPI,
  GetAllAccountsAPI,
  GetAllAccountsWithLightweightAPI,
  GetAllBillsAPI,
  GetAllChallansAPI,
  UpdateBillAPI,
  UpdateChallanAPI,
  GetPartyPurchasesAPI,
  GetAllBanksAPI,
  GetAllPurchasesAPI,
  GetAllLedgersAPI,
} from "../../config/api";
import { Autocomplete } from "@material-ui/lab";
import { createFilterOptions } from "@material-ui/lab/Autocomplete";
import AddIcon from "@material-ui/icons/Add";
import _ from "lodash";
import DeleteIcon from "@material-ui/icons/Delete";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { calculateRunningBalance } from "../../utils/index.js";

import moment from "moment";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";

const paymentPartyFilterOptions = createFilterOptions({
  matchFrom: "any",
  limit: 500,
});

const styles = {
  formControl: {
    paddingBottom: "10px",
    margin: "27px 0 0 0",
    position: "relative",
    verticalAlign: "unset",
  },
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
  },
};

const useStyles = makeStyles(styles);
const columns = [
  { id: "paymentMode", label: "Payment Mode" },
  {
    id: "paymentAmount",
    label: "Payment Amount*",
    format: (value) => {
      const numValue = Number(value);
      if (isNaN(numValue)) return value;
      return numValue.toLocaleString("en-IN", {
        maximumFractionDigits: 2,
        style: "currency",
        currency: "INR",
      });
    },
  },
  // {id: 'createdAt', label: 'Created At', format: value => value ? moment(value).format('DD-MM-YYYY') : ''},
  { id: "action", label: "Action" },
];
const paymentModes = ["Cheque and Direct", "Cash and Direct"];
let paymentTypes = [
  {
    label: "Challan",
    value: "challanSale",
    partyType: "sale",
  },
  {
    label: "Bill",
    value: "billSale",
    partyType: "sale",
  },
  {
    label: "Challan",
    value: "challanPurchase",
    partyType: "purchase",
  },
  {
    label: "Bill",
    value: "billPurchase",
    partyType: "purchase",
  },
];

export default function PaymentAdd(props) {
  const classes = useStyles();
  const theme = useTheme();
  const userInfo = useSelector((state) => state.userReducer.userInfo);
  const authToken = useSelector((state) => state.userReducer.authToken);

  const { open, close, fetchData } = props;
  const fullScreen = useMediaQuery(theme.breakpoints.down("xs"));

  const [bills, setBills] = useState([]);
  const [selectedBills, setSelectedBills] = useState(null);
  const [challans, setChallans] = useState([]);
  console.log("normal bills", bills, "normal challans>>", challans);
  const [purchaseChallans, setPurchaseChallans] = useState([]);
  const [purchaseBills, setPurchaseBills] = useState([]);
  console.log(
    purchaseBills,
    "purchaseBills",
    "purchaseChallans",
    purchaseChallans
  );
  const [selectedChallans, setSelectedChallans] = useState([]);
  const [selectedChallan, setSelectedChallan] = useState([]);
  console.log(selectedChallan, "selectedChallan126");

  const [selectedBill, setSelectedBill] = useState([]);
  const [payments, setPayments] = useState([]);
  const [paymentMode, setPaymentMode] = useState("");
  const [paymentAmount, setPaymentAmount] = useState(0);
  const [chequeNo, setChequeNo] = useState("");
  const [chequeDate, setChequeDate] = useState("");
  const [bankName, setBankName] = useState("");
  const [branchName, setBranchName] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("");
  const [paymentDetails, setPaymentDetails] = useState("");
  console.log(paymentDetails, "paymentDetails");
  const [refNo, setRefNo] = useState(Math.floor(Math.random() * 1000000000));
  const [accounts, setAccounts] = useState([]);
  const [selectedPartyType, setSelectedPartyType] = useState(null);
  const [selectedParty, setSelectedParty] = useState(null);
  const [paymentType, setPaymentType] = useState("");
  console.log(">>>>", selectedBills);
  const [runningBalance, setRunningBalance] = useState("");
  const [totalBalance, setTotalBalance] = useState("");

  // State variables for calculated running balances
  const [calculatedChallanBalance, setCalculatedChallanBalance] = useState(0);
  const [calculatedBillBalance, setCalculatedBillBalance] = useState(0);
  const [isCalculatingBalances, setIsCalculatingBalances] = useState(false);

  const [purchase, setPurchase] = useState([]);
  const [paymentDate, setPaymentDate] = useState(null);
  const [disableSaveButton, setDisableSaveButton] = useState(false);
  const [banks, setBanks] = useState([]);
  const [bank, setBank] = useState(null);
  const [error, setError] = useState("");
  const [minPaymentAmount, setMinPaymentAmount] = useState(0);

  const getChallanCode = (row) =>
    paymentType === "challanPurchase" ? row?.challanNo : row?.code;

  const getChallanTotalAmount = (row) => {
    if (!row) return 0;
    if (paymentType === "challanPurchase") {
      return Number(
        row?.totalAmount ?? row?.amount ?? row?.grandTotal ?? row?.netAmount ?? 0
      );
    }
    return Number(
      row?.amount ?? row?.totalAmount ?? row?.grandTotal ?? row?.netAmount ?? 0
    );
  };

  const getChallanPendingAmount = (row) => {
    if (!row) return 0;
    const pendingRaw =
      row?.pendingAmount ??
      row?.pendingChallanAmount ??
      row?.remainingAmount ??
      row?.balanceAmount;
    const pendingNum =
      pendingRaw != null && pendingRaw !== "" ? Number(pendingRaw) : NaN;
    // If pending is missing OR comes back as 0/negative, fall back to challan amount.
    // This matches UX expectation: show challan amount when pending isn't provided.
    if (Number.isFinite(pendingNum) && pendingNum > 0) return pendingNum;
    return getChallanTotalAmount(row);
  };

  const handlePaymentChange = (value) => {
    const num = parseFloat(value);
    if (!isNaN(num)) {
      if (num <= 0) {
        setError("Amount must be greater than 0");
        setPaymentAmount(value);
      } else if (minPaymentAmount > 0 && num - minPaymentAmount > 0.009) {
        setError(`Payment cannot exceed pending: ₹${minPaymentAmount.toFixed(2)}`);
        setPaymentAmount(value);
      } else {
        setPaymentAmount(num);
        setError("");
      }
    } else {
      setPaymentAmount("");
      setError("Please enter a valid amount");
    }
  };

  console.log(bank, "<<<<selBAnk");

  // Fetch bank data
  const _getBanks = async () => {
    try {
      const res = await axios.get(GetAllBanksAPI(userInfo.entity), {
        headers: { Authorization: `Bearer ${authToken}` },
      });
      setBanks(res.data.banks);
    } catch (e) {
      toast.error("Error fetching banks");
    }
  };

  // Function to calculate running balances using global function
  // This uses the optimized calculateRunningBalance function from utils/index.js
  // which handles transactionType and activityType parameters for filtering
  async function _calculateRunningBalances() {
    if (!selectedParty) return;

    setIsCalculatingBalances(true);
    try {
      // Calculate Challan running balance
      const challanBalance = await calculateRunningBalance(
        selectedParty,
        "Challan",
        userInfo,
        authToken,
        GetAllLedgersAPI
      );
      setCalculatedChallanBalance(challanBalance);

      // Calculate Bill running balance
      const billBalance = await calculateRunningBalance(
        selectedParty,
        "Bill",
        userInfo,
        authToken,
        GetAllLedgersAPI
      );
      setCalculatedBillBalance(billBalance);
    } catch (error) {
      console.error('Error calculating running balances:', error);
      // Fallback to existing values
      setCalculatedChallanBalance(selectedParty.runningChallanBalance || 0);
      setCalculatedBillBalance(selectedParty.runningBillBalance || 0);
    } finally {
      setIsCalculatingBalances(false);
    }
  }

  // Function to reset all fields when party type or party changes
  const resetFields = () => {
    setPaymentType("");
    setSelectedChallan([]);
    setSelectedBill([]);
    setPayments([]);
    setPaymentMode("");
    setPaymentAmount(0);
    setChequeNo("");
    setChequeDate("");
    setBankName("");
    setBranchName("");
    setPaymentMethod("");
    setPaymentDetails("");
    setRefNo(Math.floor(Math.random() * 1000000000));
    setRunningBalance("");
    setTotalBalance("");
    setMinPaymentAmount(0);
    setCalculatedChallanBalance(0);
    setCalculatedBillBalance(0);
    setError("");
    setBank(null);
    setBills([]);
    setChallans([]);
    setPurchaseChallans([]);
    setPurchaseBills([]);
    setPurchase([]);
  };

  useEffect(() => {
    _getAccounts();
    resetFields();
  }, [selectedPartyType]);

  useEffect(() => {
    if (selectedParty) {
      resetFields();
      _getChallans();
      _getBills();
      _getPurchase();
      _getBanks();
    }
  }, [selectedParty]);

  useEffect(() => {
    if (selectedParty && selectedParty.showRunningBalance) {
      _calculateRunningBalances();
    }
  }, [selectedParty, paymentType]);

  useEffect(() => {
    if (selectedParty && selectedParty.showRunningBalance) {
      let rb = 0;
      console.log(rb, "<<<<<<<<<runningBalance");
      if (paymentType === "challanSale") {
        rb = calculatedChallanBalance;
        setTotalBalance(_.round(rb, 2));
        setRunningBalance(_.round(calculatedChallanBalance, 2));
      } else if (paymentType === "billSale") {
        rb = calculatedBillBalance;
        setTotalBalance(_.round(rb, 2));
        setRunningBalance(_.round(calculatedBillBalance, 2));
      } else if (paymentType === "challanPurchase") {
        rb = calculatedChallanBalance;
        setTotalBalance(_.round(rb, 2));
        setRunningBalance(_.round(calculatedChallanBalance, 2));
      } else if (paymentType === "billPurchase") {
        rb = Number(-calculatedBillBalance);
        setTotalBalance(_.round(rb, 2));
        setRunningBalance(_.round(calculatedBillBalance, 2));
      }
    }
  }, [calculatedChallanBalance, calculatedBillBalance, paymentType]);

  useEffect(() => {
    if (selectedParty && selectedPartyType === "sale") {
      _getChallans(); // For sale
    } else if (
      selectedParty &&
      selectedPartyType === "purchase" &&
      paymentType
    ) {
      _getChallans(); // For purchase only after paymentType is selected
    }
  }, [selectedParty, selectedPartyType, paymentType]);

  useEffect(() => {
    if (selectedChallans) {
      setSelectedBills(null);
    } else {
      setSelectedChallans(null);
    }
  }, [selectedChallans]);

  useEffect(() => {
    if (selectedBills) {
      setSelectedChallans(null);
    } else {
      setSelectedBills(null);
    }
  }, [selectedBills]);

  async function _getPurchase() {
    try {
      let res = await axios.get(GetPartyPurchasesAPI(selectedParty._id), {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      setPurchase(res.data.purchase);
    } catch (err) {
      console.log(err);
      // toast.error(("Something went wrong, Please Contact Admin") , {
      //   position: "top-center",
      //   autoClose: 1500,
      //   hideProgressBar: false,
      //   closeOnClick: true,
      //   pauseOnHover: true,
      //   draggable: true,
      //   progress: undefined,
      //   theme: "light",
      //   });
    }
  }

  console.log(challans, "My challans in payment add");

  async function _getAccounts() {
    try {
      // Use lightweight endpoint with partyType filter if available
      let url = GetAllAccountsWithLightweightAPI(userInfo.entity, selectedPartyType || null);
      let res = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      // If partyType filter was not applied, filter client-side
      let accounts = selectedPartyType
        ? (res.data.accounts || []).filter((account) => account.partyType === selectedPartyType)
        : (res.data.accounts || []);
      setAccounts(accounts);
    } catch (err) {
      // console.log(err);
      // toast.error(("Something went wrong, Please Contact Admin") , {
      //   position: "top-center",
      //   autoClose: 1500,
      //   hideProgressBar: false,
      //   closeOnClick: true,
      //   pauseOnHover: true,
      //   draggable: true,
      //   progress: undefined,
      //   theme: "light",
      //   });
    }
  }

  async function _getBills() {
    try {
      // Include Pending + Partial records.
      // We only need not-fully-paid docs for partial payment flow (`isPaid=false`).
      let query = `&userId=${selectedParty._id}&isPaid=false`;
      let res = await axios.get(GetAllBillsAPI(userInfo.entity) + query, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      setBills(res.data.bills);
    } catch (err) {
      // console.log("error:", err);
      // toast.error(("Something went wrong, Please Contact Admin") , {
      //   position: "top-center",
      //   autoClose: 1500,
      //   hideProgressBar: false,
      //   closeOnClick: true,
      //   pauseOnHover: true,
      //   draggable: true,
      //   progress: undefined,
      //   theme: "light",
      //   });
    }
  }

  async function _getChallans() {
    try {
      // Include Pending + Partial records.
      // We only need not-fully-paid challans for partial payment flow (`isPaid=false`).
      let query = `&userId=${selectedParty._id}&isBilled=false&isPaid=false`;
      let api;

      if (selectedPartyType === "sale") {
        api = GetAllChallansAPI(userInfo.entity);
        const res = await axios.get(api + query, {
          headers: { Authorization: `Bearer ${authToken}` },
        });
        console.log(res.data, "res.data.challans");
        setChallans(res.data.challans);
      } else if (selectedPartyType === "purchase") {
        api = GetAllPurchasesAPI(userInfo.entity);

        if (paymentType === "challanPurchase") {
          console.log("fetching challanPurchase>>>>>>", "first");
          query += `&purchaseType=Challan`;
          const res = await axios.get(api + query, {
            headers: { Authorization: `Bearer ${authToken}` },
          });
          console.log(res.data.purchases, "res.data.purchaseChallans");
          setPurchaseChallans(res.data.purchases);
        } else if (paymentType === "billPurchase") {
          query += `&purchaseType=Bill`;
          const res = await axios.get(api + query, {
            headers: { Authorization: `Bearer ${authToken}` },
          });
          console.log(res.data, "res.data.purchaseBills");
          setPurchaseBills(res.data.purchases);
        }
      }
    } catch (err) {
      console.error("Error fetching challans:", err);
    }
  }

  async function _onSave() {
    if (disableSaveButton) return;
    try {
      let amount = 0,
        code = "",
        paymentFor = "",
        paidAmount = 0;
      amount = Number(paymentAmount);
      if (paymentType === "challanSale") {
        paymentFor = "Sale Challan";
      }
      if (paymentType === "billSale") {
        paymentFor = "Sale Bill";
      }
      if (paymentType === "challanPurchase") {
        paymentFor = "Purchase Challan";
      }
      if (paymentType === "billPurchase") {
        paymentFor = "Purchase Bill";
      }

      let payment = {
        paymentFor,
        party: selectedParty._id,
        selectedChallan,
        selectedBill,
        // {
        //   _id: selectedParty._id,
        //   accountCode: selectedParty.accountCode,
        //   partyType: selectedParty.partyType,
        //   name: selectedParty.name,
        // },

        amount,
        entity: userInfo.entity,
        paymentDate: paymentDate == null ? moment() : paymentDate,
        payments: {
          paymentMode,
          paymentAmount,
          chequeNo,
          chequeDate,
          bankName,
          branchName,
          paymentMethod,
          refNo,
          createdAt: new Date(),
        },
        bankName: bank.bankName,
        bankAccountNumber: bank.acNo,
        paymentDetails,
      };
      // Validation for required fields
      if (!selectedPartyType) {
        toast.error("Please select Party Type!", {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        return;
      }

      if (!selectedParty) {
        toast.error("Please select Party!", {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        return;
      }

      if (!paymentType) {
        toast.error("Please select Payment Type!", {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        return;
      }

      if (!paymentMode) {
        toast.error("Please select Payment Mode!", {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        return;
      }

      if (!paymentAmount || paymentAmount === "" || paymentAmount <= 0) {
        toast.error("Please enter a valid Payment Amount!", {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        return;
      }
      if ((selectedChallan?.length || selectedBill?.length) && minPaymentAmount > 0) {
        const entered = Number(paymentAmount);
        if (!Number.isFinite(entered)) {
          toast.error("Please enter a valid amount", {
            position: "top-center",
            autoClose: 2000,
          });
          return;
        }
        if (entered - Number(minPaymentAmount) > 0.009) {
          toast.error(`Payment cannot exceed pending: ₹${Number(minPaymentAmount).toFixed(2)}`, {
            position: "top-center",
            autoClose: 2500,
          });
          return;
        }
      }

      if (paymentMode === "Cash and Direct" && !paymentMethod) {
        toast.error("Please enter Payment Method for Cash and Direct!", {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        return;
      }

      if (paymentMode === "Cheque and Direct") {
        if (!chequeNo) {
          toast.error("Please enter Cheque No. for Cheque payment!", {
            position: "top-center",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          return;
        }
        if (!chequeDate) {
          toast.error("Please enter Cheque Date for Cheque payment!", {
            position: "top-center",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          return;
        }
        if (!bankName) {
          toast.error("Please enter Party Bank Name for Cheque payment!", {
            position: "top-center",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          return;
        }
        if (!branchName) {
          toast.error("Please enter Party Branch Name for Cheque payment!", {
            position: "top-center",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          return;
        }
      }

      if (!bank) {
        toast.error("Please select Bank!", {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        return;
      }

      if (!paymentDetails || paymentDetails.trim() === "") {
        toast.error("Please enter Payment Details!", {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        return;
      }

      // If no challans/bills selected, set default payment details
      if (!selectedChallan.length && !selectedBill.length) {
        const paymentDescription = `General ${paymentType === "challanPurchase" || paymentType === "billPurchase"
          ? "Purchase"
          : "Sale"
          } Payment`;
        payment.paymentDetails = paymentDetails || paymentDescription;
      }

      setDisableSaveButton(true);
      let res = await axios.post(CreatePaymentAPI(), payment, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      toast.success("Successfully Added!", {
        position: "top-center",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      close();
      window.location.reload();
      // fetchData();
    } catch (e) {
      // console.log("err:", e);
      // toast.error(("Something went wrong, Please Contact Admin") , {
      //   position: "top-center",
      //   autoClose: 1500,
      //   hideProgressBar: false,
      //   closeOnClick: true,
      //   pauseOnHover: true,
      //   draggable: true,
      //   progress: undefined,
      //   theme: "light",
      //   });
    } finally {
      setDisableSaveButton(false);
    }
  }
  useEffect(() => {
    if (open) {
      setDisableSaveButton(false);
      setSelectedPartyType(null);
      setSelectedParty(null);
      setPaymentType("");
      setSelectedChallan([]);
      setSelectedBill([]);
      setPayments([]);
      setPaymentMode("");
      setPaymentAmount(0);
      setChequeNo("");
      setChequeDate("");
      setBankName("");
      setBranchName("");
      setPaymentMethod("");
      setPaymentDetails("");
      setRefNo(Math.floor(Math.random() * 1000000000));
      setRunningBalance("");
      setTotalBalance("");
      setMinPaymentAmount(0);
      setCalculatedChallanBalance(0);
      setCalculatedBillBalance(0);
      setIsCalculatingBalances(false);
      setError("");
      setBank(null);
      setBills([]);
      setChallans([]);
      setPurchaseChallans([]);
      setPurchaseBills([]);
      setPurchase([]);
    }
  }, [open]);
  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={close}
      aria-labelledby="responsive-dialog-title"
    >
      <GridContainer>
        <GridItem xs={12} sm={12}>
          <Card>
            <CardHeader color="primary">
              <h4 className={classes.cardTitleWhite}>Add Payment</h4>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  <Autocomplete
                    id="partyType"
                    className={classes.formControl}
                    options={["sale", "purchase"]}
                    value={selectedPartyType}
                    onChange={(event, value) => setSelectedPartyType(value)}
                    getOptionLabel={(option) => option}
                    renderInput={(params) => (
                      <TextField {...params} label="Select Party Type*" />
                    )}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                  <Autocomplete
                    id="party"
                    className={classes.formControl}
                    options={accounts}
                    value={selectedParty}
                    filterOptions={paymentPartyFilterOptions}
                    onChange={(event, value) => {
                      setSelectedParty(value);
                      // Clear payment type and running amount when party is cleared
                      if (!value) {
                        setPaymentType("");
                        setTotalBalance("");
                        setRunningBalance("");
                        setCalculatedChallanBalance(0);
                        setCalculatedBillBalance(0);
                      }
                    }}
                    getOptionLabel={(option) => option.name}
                    renderInput={(params) => (
                      <TextField {...params} label="Select Party*" />
                    )}
                  />
                </GridItem>
                <GridItem xs={12}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      Payment Type*
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={paymentType}
                      label="Type"
                      onChange={(e) => {
                        e.preventDefault();
                        setPaymentType(e.target.value);
                      }}
                    >
                      {paymentTypes.map(({ label, value, partyType }) => {
                        if (
                          selectedParty &&
                          selectedParty.partyType === partyType
                        ) {
                          return <MenuItem value={value}>{label}</MenuItem>;
                        }
                      })}
                    </Select>
                  </FormControl>
                </GridItem>
                {selectedParty
                  ? console.log(selectedParty, paymentType, "selectedParty")
                  : null}
                {selectedParty ? (
                  <>
                    {paymentType === "challanSale" ||
                      paymentType === "challanPurchase" ? (
                      <>
                        <GridItem xs={12} sm={12} md={12}>
                          <Autocomplete
                            multiple
                            id="challans"
                            className={classes.formControl}
                            options={
                              (paymentType === "challanPurchase"
                                ? purchaseChallans
                                : challans
                              )?.filter((item) =>
                                paymentType === "challanPurchase"
                                  ? item?.challanNo
                                  : item?.code
                              ) || []
                            }
                            value={selectedChallan}
                            onChange={(event, value = []) => {
                              setSelectedChallan(value);

                              const details = value
                                .map((item) => {
                                  const code = getChallanCode(item);
                                  const amount = getChallanTotalAmount(item);
                                  return `${code} (₹${Number(amount).toFixed(
                                    2
                                  )})`;
                                })
                                .join(", ");

                              const paymentDescription =
                                value.length > 0
                                  ? `${paymentType === "challanPurchase"
                                    ? "Purchase"
                                    : "Sale"
                                  } Challan Payment for: ${details}`
                                  : "";

                              setPaymentDetails(paymentDescription);

                              // FULL-PAYMENT ONLY: total pending across selected challans
                              const totalPending = value.reduce((sum, item) => {
                                const pending = getChallanPendingAmount(item);
                                return sum + (Number.isFinite(pending) ? pending : 0);
                              }, 0);

                              setMinPaymentAmount(totalPending);
                              setPaymentAmount(totalPending);
                            }}
                            isOptionEqualToValue={(option, value) =>
                              paymentType === "challanPurchase"
                                ? option?.challanNo === value?.challanNo
                                : option?.code === value?.code
                            }
                            getOptionLabel={(option) => {
                              const code = getChallanCode(option)?.toString();
                              const pending = getChallanPendingAmount(option);
                              return `${code} (Pending ₹${Number(pending || 0).toFixed(2)})`;
                            }}
                            renderInput={(params) => (
                              <TextField {...params} label="Select Challan" />
                            )}
                          />
                        </GridItem>
                      </>
                    ) : null}

                    {paymentType === "billSale" ||
                      paymentType === "billPurchase" ? (
                      <GridItem xs={12} sm={12} md={12}>
                        <Autocomplete
                          multiple
                          id="bills"
                          className={classes.formControl}
                          options={
                            (paymentType === "billPurchase"
                              ? purchaseBills
                              : bills
                            )?.filter((item) =>
                              paymentType === "billPurchase"
                                ? item?.billNo
                                : item?.code
                            ) || []
                          }
                          value={selectedBill}
                          onChange={(event, value = []) => {
                            setSelectedBill(value);
                            console.log(value, "value in bill");

                            const details = value
                              .map((item) => {
                                const code =
                                  paymentType === "billPurchase"
                                    ? item?.billNo
                                    : item?.code;
                                // const amount = item?.amount || 0;
                                const amount =
                                  paymentType === "billPurchase" ?
                                    item?.totalAmount || 0 : item.amount || 0;
                                return `${code} (₹${Number(amount).toFixed(
                                  2
                                )})`;
                              })
                              .join(", ");

                            const paymentDescription =
                              value.length > 0
                                ? `${paymentType === "billPurchase"
                                  ? "Purchase"
                                  : "Sale"
                                } Bill Payment for: ${details}`
                                : "";

                            setPaymentDetails(paymentDescription);

                            // FULL-PAYMENT ONLY: total pending across selected bills
                            const totalPending = value.reduce((sum, item) => {
                              const total =
                                paymentType === "billPurchase"
                                  ? Number(item?.totalAmount ?? item?.amount ?? item?.grandTotal ?? item?.netAmount ?? 0)
                                  : Number(item?.amount ?? item?.totalAmount ?? item?.grandTotal ?? item?.netAmount ?? 0);
                              const pendingRaw = item?.pendingAmount ?? item?.pendingBillAmount ?? item?.remainingAmount ?? item?.balanceAmount;
                              const pendingNum = pendingRaw != null && pendingRaw !== "" ? Number(pendingRaw) : NaN;
                              const pending = Number.isFinite(pendingNum) && pendingNum > 0 ? pendingNum : total;
                              return sum + pending;
                            }, 0);

                            setMinPaymentAmount(totalPending);
                            setPaymentAmount(totalPending);
                          }}
                          isOptionEqualToValue={(option, value) =>
                            paymentType === "billPurchase"
                              ? option?.billNo === value?.billNo
                              : option?.code === value?.code
                          }
                          getOptionLabel={(option) => {
                            const code =
                              paymentType === "billPurchase"
                                ? option?.billNo?.toString()
                                : option?.code?.toString();
                            const total =
                              paymentType === "billPurchase"
                                ? Number(option?.totalAmount ?? option?.amount ?? option?.grandTotal ?? option?.netAmount ?? 0)
                                : Number(option?.amount ?? option?.totalAmount ?? option?.grandTotal ?? option?.netAmount ?? 0);
                            const pendingRaw = option?.pendingAmount ?? option?.pendingBillAmount ?? option?.remainingAmount ?? option?.balanceAmount;
                            const pendingNum = pendingRaw != null && pendingRaw !== "" ? Number(pendingRaw) : NaN;
                            const pending = Number.isFinite(pendingNum) && pendingNum > 0 ? pendingNum : total;
                            return `${code} (Pending ₹${Number(pending || 0).toFixed(2)})`;
                          }}
                          renderInput={(params) => (
                            <TextField {...params} label="Select Bill" />
                          )}
                        />
                      </GridItem>
                    ) : null}
                  </>
                ) : null}

                <GridItem xs={12} sm={12} md={12}>
                  <MuiPickersUtilsProvider utils={DateUtils}>
                    <DatePicker
                      label="Payment Date"
                      fullWidth
                      value={paymentDate}
                      onChange={(date) => setPaymentDate(date)}
                      animateYearScrolling
                      style={{ marginTop: 22 }}
                    />
                  </MuiPickersUtilsProvider>
                </GridItem>
                <GridItem xs={6} sm={6} md={6}>
                  <CustomInput
                    labelText="Running Amount*"
                    id="runningAmount"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      type: "number",
                      disabled: true,
                      value: isCalculatingBalances ? "Calculating..." : totalBalance,
                      onChange: (event) => setTotalBalance(event.target.value),
                    }}
                  />
                </GridItem>
                <GridItem xs={6} sm={6} md={6}>
                  <Autocomplete
                    id="paymentMode"
                    className={classes.formControl}
                    options={paymentModes}
                    value={paymentMode}
                    onChange={(event, value) => setPaymentMode(value)}
                    getOptionLabel={(option) => option}
                    renderInput={(params) => (
                      <TextField {...params} label="Select Payment Mode*" />
                    )}
                  />
                </GridItem>
                {/* // Then replace the existing CustomInput with: */}
                <GridItem xs={12} sm={12} md={12}>
                  <CustomInput
                    labelText="Payment Amount*"
                    id="paymentAmount"
                    error={!!error}
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      type: "number",
                      // Allow partial payments:
                      // - min should be 0 (we validate >0 separately)
                      // - max should be the pending amount across selected challans/bills
                      min: 0,
                      max: minPaymentAmount > 0 ? minPaymentAmount : undefined,
                      value: paymentAmount,
                      onChange: (event) =>
                        handlePaymentChange(event.target.value),
                      onBlur: () => {
                        if (paymentAmount && !isNaN(paymentAmount)) {
                          setPaymentAmount(
                            parseFloat(paymentAmount).toFixed(2)
                          );
                        }
                      },
                      startAdornment: (
                        <InputAdornment position="start">₹</InputAdornment>
                      ),
                    }}
                  />
                  {error && (
                    <FormHelperText
                      error
                      style={{ marginLeft: "14px", marginTop: "-6px" }}
                    >
                      {error}
                    </FormHelperText>
                  )}
                  {minPaymentAmount > 0 && (
                    <FormHelperText style={{ marginLeft: "14px" }}>
                      Selected items pending total: ₹{minPaymentAmount.toFixed(2)} (pay any amount up to this)
                    </FormHelperText>
                  )}
                </GridItem>

                {paymentMode ? (
                  paymentMode === paymentModes[0] ? (
                    <>
                      <GridItem xs={6} sm={6} md={6}>
                        <CustomInput
                          labelText="Cheque No.*"
                          id="chequeNo"
                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            value: chequeNo,
                            onChange: (event) =>
                              setChequeNo(event.target.value),
                          }}
                        />
                      </GridItem>
                      <GridItem xs={6} sm={6} md={6}>
                        <CustomInput
                          labelText="Cheque Date*"
                          id="chequeDate"
                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            value: chequeDate,
                            onChange: (event) =>
                              setChequeDate(event.target.value),
                          }}
                        />
                      </GridItem>

                      <GridItem xs={6} sm={6} md={6}>
                        <CustomInput
                          labelText="Party Bank Name*"
                          id="bankName"
                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            value: bankName,
                            onChange: (event) =>
                              setBankName(event.target.value),
                          }}
                        />
                      </GridItem>
                      <GridItem xs={6} sm={6} md={6}>
                        <CustomInput
                          labelText="Party Branch Name*"
                          id="branchName"
                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            value: branchName,
                            onChange: (event) =>
                              setBranchName(event.target.value),
                          }}
                        />
                      </GridItem>
                    </>
                  ) : (
                    <>
                      <GridItem xs={12} sm={12} md={12}>
                        <CustomInput
                          labelText="Payment Method"
                          id="paymentMethod"
                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            value: paymentMethod,
                            onChange: (event) =>
                              setPaymentMethod(event.target.value),
                          }}
                        />
                      </GridItem>
                      {/* <GridItem xs={6} sm={6} md={6}>
                        <CustomInput
                          labelText="Ref No."
                          id="refNo"
                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            value: refNo,
                            onChange: (event) => setRefNo(event.target.value),
                          }}
                        />
                      </GridItem> */}
                    </>
                  )
                ) : null}

                <GridItem xs={12} sm={12} md={12}>
                  <Autocomplete
                    className={classes.formControl}
                    options={banks}
                    fullWidth
                    value={bank}
                    onChange={(event, value) => setBank(value)}
                    getOptionLabel={(option) => option.bankName}
                    id="banks"
                    renderInput={(params) => (
                      <TextField {...params} label="Banks" />
                    )}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                  <CustomInput
                    labelText="Payment Details*"
                    id="paymentDetails"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: paymentDetails,
                      onChange: (event) =>
                        setPaymentDetails(event.target.value),
                    }}
                  />
                </GridItem>

                {_.isEmpty(payments) ? null : (
                  <GridItem xs={12}>
                    <Table stickyHeader aria-label="sticky table">
                      <TableHead>
                        <TableRow>
                          {columns.map((column) => (
                            <TableCell
                              key={column.id}
                              align={column.align}
                              style={{ minWidth: column.minWidth }}
                            >
                              {column.label}
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {payments.map((row, index) => {
                          return (
                            <TableRow
                              hover
                              role="checkbox"
                              tabIndex={-1}
                              key={row.code}
                            >
                              {columns.map((column) => {
                                let value = row[column.id];
                                if (column.id === "action") {
                                  return (
                                    <TableCell align={"center"}>
                                      <Box
                                        display={"flex"}
                                        justifyContent={"center"}
                                      >
                                        <IconButton
                                          aria-label="delete"
                                          onClick={() => {
                                            let copy = _.clone(payments);
                                            copy.splice(index, 1);
                                            setPayments(copy);
                                          }}
                                        >
                                          <DeleteIcon />
                                        </IconButton>
                                      </Box>
                                    </TableCell>
                                  );
                                }
                                return (
                                  <TableCell
                                    key={column.id}
                                    align={column.align}
                                  >
                                    {column.format && typeof value === "number"
                                      ? column.format(value)
                                      : value}
                                  </TableCell>
                                );
                              })}
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </GridItem>
                )}
              </GridContainer>
            </CardBody>
            <CardFooter style={{ justifyContent: "center" }}>
              <Button
                disabled={disableSaveButton}
                color="primary"
                onClick={() => _onSave()}
              >
                {disableSaveButton ? "Saving…" : "Add Payment"}
              </Button>
            </CardFooter>
          </Card>
        </GridItem>
      </GridContainer>
    </Dialog>
  );
}
